var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoMapArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.168 9.808 5.7 5.658c.11-.1.188-.205.233-.312A.885.885 0 0 0 6 5a.885.885 0 0 0-.067-.346.907.907 0 0 0-.233-.312L1.168.192A.68.68 0 0 0 .688 0C.509 0 .35.058.21.175A.565.565 0 0 0 0 .63v8.738c0 .188.07.34.21.456.14.117.299.175.479.175.05 0 .21-.064.479-.192z",
    fill: "#626266",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoMapArrow);
export default __webpack_public_path__ + "static/media/geo-map-arrow.5fd4dc4728f9829035c7cc0948c2d642.svg";
export { ForwardRef as ReactComponent };